/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse
 */
export interface FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse
     */
    AccountId: number;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse
     */
    Token: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse(value: object): value is FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse {
    if (!('AccountId' in value) || value['AccountId'] === undefined) return false;
    if (!('Token' in value) || value['Token'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'AccountId': json['AccountId'],
        'Token': json['Token'],
    };
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AccountId': value['AccountId'],
        'Token': value['Token'],
    };
}

